document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (event) => {
    const target = event.target;
    
    const globalDropdownMenu = document.querySelector('#global-dropdown-menu');
    const themeFilterForm = document.querySelector('#filter');

    if (!globalDropdownMenu || !themeFilterForm) {
      return;
    }

    const button = target.closest('.filter-toggle-button');
    if (button) {
      if (button.id === 'select-all-filters-button') {
        event.preventDefault();
        const baseUrl = window.location.origin + window.location.pathname;
        window.location.href = baseUrl;
        return;
      }

      const filterId = button.dataset.filterId;
      const filterGroup = button.closest('.filter-group');
      const isThisDropdownOpen = filterGroup.classList.contains('active');

      document.querySelectorAll('.filter-group.active').forEach(group => {
        group.classList.remove('active');
      });
      globalDropdownMenu.style.display = 'none';

      if (!isThisDropdownOpen) {
        filterGroup.classList.add('active');
        const dropdownContent = document.querySelector(`#dropdown-${filterId}`).innerHTML;
        globalDropdownMenu.innerHTML = dropdownContent;

        const buttonRect = button.getBoundingClientRect();
        globalDropdownMenu.style.top = `${buttonRect.bottom}px`;
        globalDropdownMenu.style.left = `${buttonRect.left}px`;
        globalDropdownMenu.style.display = 'block';

        const dropdownRect = globalDropdownMenu.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        if (dropdownRect.right > viewportWidth) {
          globalDropdownMenu.style.left = `${buttonRect.right - dropdownRect.width}px`;
        }
      }
      return;
    }

    if (target.matches('.filter-options a')) {
      event.preventDefault();
      const filterName = target.dataset.filterName;
      const filterValue = target.dataset.filterValue;

      const checkbox = themeFilterForm.querySelector(`input[name="${filterName}"][value="${filterValue}"]`);
      if (checkbox) {
        checkbox.checked = !checkbox.checked;
        themeFilterForm.submit();
      }
      globalDropdownMenu.style.display = 'none';
      return;
    }

    const isClickInsideFilterBar = target.closest('.my-custom-filters-container');
    const isClickInsideDropdown = target.closest('#global-dropdown-menu');
    if (!isClickInsideFilterBar && !isClickInsideDropdown) {
      globalDropdownMenu.style.display = 'none';
      document.querySelectorAll('.filter-group.active').forEach(group => group.classList.remove('active'));
    }
  });
});